import React from 'react';
import { news } from "../configs/news";
import './NewsPage.scss';
import { ImageComponent } from "../components/ImageModal";
import { Link } from 'react-router-dom';

export function NewsPage() {
    return (
        <div className='news'>
            {news.map((item) => (
                <Link
                    to={`/news/${item.slug}`}
                    key={item.slug}
                    className='news__item-link'
                >
                    <div className='news__item'>
                        <div className='news__item-img-wrapper'><ImageComponent
                            src={require(`../assets/news/${item.img[0]}`)}
                            small={{ width: '250px', height: 'auto' }}
                            big={{ width: 'auto', height: '90vh' }}
                        /></div>
                        <div className='news__item-wrapper'>
                            <p className='news__item-title'>{item.title}</p>
                            <span
                                className='news__item-text'
                                dangerouslySetInnerHTML={{ __html: item.text.slice(0, 200 - item.title.length) + '...' }}
                            ></span>
                            <span className='news__item-readmore'>
                                <span className='news__item-readmore-link'>Читать далее</span>
                            </span>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    )
}
